import { render, staticRenderFns } from "./Horarios.vue?vue&type=template&id=0a98abde&scoped=true&"
import script from "./Horarios.vue?vue&type=script&lang=js&"
export * from "./Horarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a98abde",
  null
  
)

export default component.exports